import React from 'react';
import {LoadingSpinner} from '@albert-io/atomic';
import PracticeView from 'components/PracticeView/PracticeView.react';
import TitleBar from 'components/PracticeView/TitleBar/TitleBar.react';

import './loading-view.scss';

interface Props {
  hasTitleBar?: boolean;
}

const LoadingView = ({hasTitleBar = true}: Props) => {
  return (
    <PracticeView
      titleBar={hasTitleBar ? <TitleBar className='background-brand' /> : undefined}
      stageComponent={
        <div className='practice-view-spinner-wrapper'>
          <LoadingSpinner size={2} />
        </div>
      }
    />
  );
};

export default LoadingView;
